import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container maxWidth-sm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Develop Data Export")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-9" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Choose the dates for which you wish to download data. Only Develop plans "),
      /*#__PURE__*/_createElementVNode("b", null, "started"),
      /*#__PURE__*/_createTextVNode(" within these dates (inclusive) will be included. ")
    ])
  ])
], -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-10 col-sm-offset-1 text-big" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  for: "earliest"
}, "Earliest start:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  for: "latest"
}, "Latest start:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = ["disabled"]

import moment from "dayjs";
import { computed, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'develop-data-export-page',
  setup(__props) {

const earliest = ref<string>("");
const latest = ref<string>("");

function pickSevenDays(): void {
  earliest.value = moment().subtract(7, "day").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

onMounted(() => {
  pickSevenDays();
});

const isValid = computed(() => {
  const earliestMoment = moment(earliest.value);
  const latestMoment = moment(latest.value);

  return (
    earliestMoment.isValid() &&
    latestMoment.isValid() &&
    latestMoment.isAfter(earliestMoment) &&
    earliestMoment.isBefore(moment())
  );
});

const downloadUrl = computed(() => {
  return `/admin/crmexport/developdata/?fromDate=${earliest.value}&toDate=${latest.value}`;
});

function download(): void {
  if (isValid.value) {
    window.location.assign(downloadUrl.value);
  }
}

function pickPastThirtyDays(): void {
  earliest.value = moment().subtract(30, "day").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

function pickPastThreeMonths(): void {
  earliest.value = moment().subtract(3, "month").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

function pickPastSixMonths(): void {
  earliest.value = moment().subtract(6, "month").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

function pickPastYear(): void {
  earliest.value = moment().subtract(12, "month").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

function pickYearToDate(): void {
  earliest.value = moment().startOf("year").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "col-sm-9" }, [
        _createElementVNode("p", null, [
          _createElementVNode("small", null, [
            _createTextVNode(" (Examples: "),
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: pickSevenDays
            }, "Last 7 days"),
            _createTextVNode(", "),
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: pickPastThirtyDays
            }, "Last 30 days"),
            _createTextVNode(", "),
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: pickPastThreeMonths
            }, "Last 3 months"),
            _createTextVNode(", "),
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: pickPastSixMonths
            }, "Last 6 months"),
            _createTextVNode(", "),
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: pickPastYear
            }, "Last year"),
            _createTextVNode(", "),
            _createElementVNode("a", {
              href: "javascript:void(0)",
              onClick: pickYearToDate
            }, "Year to date"),
            _createTextVNode(") ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-control",
            id: "fromDatetime",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((earliest).value = $event)),
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, earliest.value]
          ]),
          _hoisted_9,
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-control",
            id: "latest",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((latest).value = $event)),
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, latest.value]
          ])
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "btn btn-lg btn-primary",
            onClick: download,
            disabled: !isValid.value,
            style: {"margin-left":"10px"}
          }, " Download CSV ", 8, _hoisted_13)
        ])
      ])
    ])
  ]))
}
}

})